import { Confirmation_, Slider_ } from 'monica-alexandria';
import React, { useEffect, useState } from 'react';
import 'react-calendar/dist/Calendar.css';
import { useTranslation } from 'react-i18next';
import Edit_Title from './Edit_Title';
import Select_Campaign from './Select_Campaign';
import Edit_Comment from './Edit_Comment';
import Edit_Kpi from './Edit_Kpi';
import Select_Kpis from './Select_Kpis';


export default function Slider_Section(props) {
    const { t } = useTranslation();

    const [sliderText, setSliderText] = useState('');
    
    return (
        <Slider_
            onClick={() => props.closeSlider()}
            onClose={() => props.closeSlider()}
            id={"AdSnap_Google_Slider_Section_1"}
            text={t('Done')}
            title={sliderText}
        >

                    
            {props.activeSlider === 'edit_title' && (
                <Edit_Title
                    setSliderText={setSliderText}
                    report={props.report}
                    setReport={props.setReport}
                />
            )}

            {props.activeSlider === 'select_campaign' && (
                <Select_Campaign
                    setSliderText={setSliderText}
                    report={props.report}
                    setReport={props.setReport}
                    googleResponses={props.googleResponses}
                    setGoogleResponses={props.setGoogleResponses}
                />
            )}

            {props.activeSlider === 'edit_comment' && (
                <Edit_Comment
                    setSliderText={setSliderText}
                    report={props.report}
                    setReport={props.setReport}
                    data={props.activeSlot}
                />
            )}

            {props.activeSlider === 'edit_kpi' && (
                <Edit_Kpi
                    setSliderText={setSliderText}
                    report={props.report}
                    setReport={props.setReport}
                    data={props.activeSlot}
                    googleResponses={props.googleResponses}
                />
            )}

            {props.activeSlider === 'select_kpis' && (
                <Select_Kpis
                    setSliderText={setSliderText}
                    report={props.report}
                    setReport={props.setReport}
                    data={props.activeSlot}
                    googleResponses={props.googleResponses}
                    alertMessage={props.alertMessage}
                />
            )}
        </Slider_>
    );
}
